import { Device } from '@twilio/voice-sdk';

const phoneIdentity = "8178890700";

async function initializeSoftphoneEngine() {
    const statusDiv = document.getElementById("status");
    const activateBtn = document.getElementById("activate-btn");
    
    statusDiv.innerText = "🚀 Activating background firewall channels...";
    statusDiv.style.color = "#00aaff";

    try {
        const tokenResponse = await fetch(`https://run.app{phoneIdentity}`);
        const data = await tokenResponse.json();
        
        if (!data.token) {
            statusDiv.innerText = "❌ Failed to retrieve cloud network token.";
            statusDiv.style.color = "#ff0000";
            return;
        }

        const device = new Device(data.token, {
            codecPreferences: ['opus', 'pcmu'],
            fakeLocalAudioTrack: true,
            enableIceRestart: true
        });

        await device.register();
        
        // Update user interface graphics to confirm success
        statusDiv.innerText = "🟢 Shield Active! Connected to secure matrix network.";
        statusDiv.style.color = "#00ff00";
        activateBtn.innerText = "🔒 SYSTEM PROTECTED";
        activateBtn.style.backgroundColor = "#1f1f1f";
        activateBtn.style.color = "#00ff00";
        activateBtn.style.boxShadow = "none";
        activateBtn.disabled = true;

        device.on('incoming', function(call) {
            console.log("🚨 INCOMING PRISON CALL INTERCEPTED NATIVELY!");
            if (confirm("🚨 Incoming Secure Call via App! Would you like to accept?")) {
                call.accept();
            } else {
                call.reject();
            }
        });

    } catch (error) {
        statusDiv.innerText = "💥 Critical connection handshake failure.";
        statusDiv.style.color = "#ff0000";
        console.error(error);
    }
}

// 🟢 CRITICAL TRANSFORMATION: Waits until you physically click the green button on your screen layout
document.addEventListener("DOMContentLoaded", () => {
    const activateBtn = document.getElementById("activate-btn");
    activateBtn.addEventListener("click", initializeSoftphoneEngine);
});
